var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
var NavigationComponent = (function () {
    function NavigationComponent(router, userService, translateService) {
        var _this = this;
        this.router = router;
        this.userService = userService;
        this.translateService = translateService;
        this.ngUnsubscribe = new Subject();
        this.currentPage = '';
        this.navigationItems = [
            {
                link: 'dashboard',
                title: 'NAVIGATION.navHome',
            },
            {
                link: 'favs',
                title: 'NAVIGATION.navMyPrograms',
            },
            {
                link: 'exercises',
                title: 'NAVIGATION.navAllExercises',
            },
            {
                link: 'stats',
                title: 'NAVIGATION.navStats',
            },
            {
                link: 'notification',
                title: 'NAVIGATION.navReminder',
            },
        ];
        this.showNavOptions = false;
        router.events.takeUntil(this.ngUnsubscribe).subscribe(function () {
            _this.checkCurrentPage();
        });
    }
    NavigationComponent.prototype.getCompanyData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var companyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userService.getCompany()];
                    case 1:
                        companyData = _a.sent();
                        if (companyData.activateAchievements) {
                            // Use translations for achievements menu
                            this.navigationItems[3].title = 'NAVIGATION.navAchievements';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NavigationComponent.prototype.ngOnInit = function () {
        this.checkCurrentPage();
        this.getCompanyData();
    };
    NavigationComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    NavigationComponent.prototype.checkCurrentPage = function () {
        for (var _i = 0, _a = this.navigationItems; _i < _a.length; _i++) {
            var item = _a[_i];
            if (this.checkRouterUrl(item.link)) {
                this.currentPage = item;
                break;
            }
        }
    };
    NavigationComponent.prototype.checkRouterUrl = function (url) {
        return this.router.url.indexOf(url) !== -1;
    };
    NavigationComponent.prototype.toggleNavOptions = function () {
        this.showNavOptions = !this.showNavOptions;
    };
    return NavigationComponent;
}());
export { NavigationComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/components/navigation/navigation.component.ts.pre-build-optimizer.js